import {Block} from "./index";
import Line from "../Line";

export class Callback extends Block {
  constructor(props = {}) {
    super(props);
    this.children = this.children || [new Line({parent: this})];
    delete this.data;
  }

  get type() {
    return "Callback";
  }

  get category() {
    return "Callback";
  }

  toJavascript() {
    const code = this.linesToJavascript(this.children);
    return `async function() {\n${code}\n}`;
  }

  getLines() {
    return this.children;
  }

  addLineAt(line, index) {
    line.parent = this;
    this.children.splice(index, 0, line);
  }
}
